import { useMemo } from 'react';

import { HUBSPOT_SELECTION_MODAL_ID } from '@/app/[locale]/business/_components/HubspotSelectionModal/index';
import { useHubspotFormsContext } from '@/app/[locale]/business/_contexts/HubspotFormsContext';
import type { LandingPageCardData } from '@/app/components/LandingPage/LandingPageCards/types';

export default function useBusinessGalleryCards() {
  const { setActiveModal } = useHubspotFormsContext();

  const cards: LandingPageCardData[] = useMemo(() => {
    return [
      {
        link: {
          target: '_blank',
          href: 'https://app.smartsheet.com/b/form/41a3a719a4784cfcbc24c0f6974ec04f',
          label: 'business_gallery_gift_card_action',
        },
        description: 'business_gallery_gift_card_description',
        id: 'business_gallery_gift_card',
        image: {
          localizedAlt: 'business_image_gift_cards_alt',
          src: '/blue-sky/oura-for-business/business-gift-cards-hd.png',
        },
        title: 'business_gallery_gift_card_title',
      },
      {
        link: {
          dataCy: 'business-gallery-bulk-order-action-button',
          onClick: (event) => {
            event.preventDefault();
            setActiveModal(HUBSPOT_SELECTION_MODAL_ID);
          },
          href: '#',
          label: 'business_gallery_bulk_order_action',
        },
        description: 'business_gallery_bulk_order_description',
        id: 'business_gallery_bulk_order',
        image: {
          localizedAlt: 'business_image_oura_ring_alt',
          src: '/blue-sky/oura-for-business/business-bulk-orders-hd.png',
        },
        title: 'business_gallery_bulk_order_title',
      },
    ];
  }, [setActiveModal]);

  return cards;
}
